export default "__VITE_ASSET__0f38deb0__"